import { render } from "./WalletItem.vue?vue&type=template&id=f40b2a3c&scoped=true"
import script from "./WalletItem.vue?vue&type=script&lang=js"
export * from "./WalletItem.vue?vue&type=script&lang=js"

import "./WalletItem.vue?vue&type=style&index=0&id=f40b2a3c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40b2a3c"]])

export default __exports__